module.exports = __webpack_public_path__ + "static/images/dialog-gift-bg2.26ce19f.png";